// common configurations of CN marketplace
import { MEDIA_CENTRAL_LINKS } from '@/configs/common';
import { ASIN_ITEM_ICONS_URLS } from '@/configs/imageLink';

// CN encrypted marketplaceId
export const ENCRYPTED_MARKETPLACE_ID = 'AAHKV2X7AFYLW';

// CN GS APP Locale
export const LOCALE = {
  ZH_CN: 'zh-CN'
};
export const ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP = {
  AAHKV2X7AFYLW: 'zh-CN',
  ATVPDKIKX0DER: 'en-US'
};

// Webapp subdomain configured in Cloudfront
export const WEBAPP_SUBDOMAIN = Object.freeze({
  BETA: 'https://beta-cn.gsweb.ags.a2z.org.cn',
  GAMMA: 'https://gamma-cn.gsweb.ags.a2z.org.cn',
  PROD: 'https://globalstore.amazon.cn'
});

// The configuration of Cloudwatch RUM
export const CLOUDWATCH_RUM_CONFIG = Object.freeze({
  BETA: {
    CONFIG: {
      sessionSampleRate: 1,
      guestRoleArn:
        'arn:aws:iam::552638187494:role/cw-rum-unauthenticated-role-beta',
      identityPoolId: 'us-east-1:1cf71860-1830-4e71-ba67-ca2ac848d35a',
      endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
      telemetries: ['errors', 'performance', 'http'],
      allowCookies: true,
      enableXRay: true
    },
    APPLICATION_ID: '2ff6b335-7de7-42dd-9c4f-cdea5ae1190b',
    APPLICATION_VERSION: '1.0.0',
    APPLICATION_REGION: 'us-east-1'
  },
  PROD: {
    CONFIG: {
      sessionSampleRate: 1,
      guestRoleArn:
        'arn:aws:iam::552638187494:role/cw-rum-unauthenticated-role-prod',
      identityPoolId: 'us-east-1:e84c5551-db1b-41dc-b2ff-216426874048',
      endpoint: 'https://dataplane.rum.us-east-1.amazonaws.com',
      telemetries: ['errors', 'performance', 'http'],
      allowCookies: true,
      enableXRay: true
    },
    APPLICATION_ID: '9052c0be-0e2c-4812-8c05-a2422d7e133e',
    APPLICATION_VERSION: '1.0.0',
    APPLICATION_REGION: 'us-east-1'
  },
  getConfig() {
    return location.href.includes(WEBAPP_SUBDOMAIN.PROD)
      ? this.PROD
      : this.BETA;
  }
});

// External Platform
export const EXTERNAL_PLATFORM = Object.freeze({
  MINIAPP: 'MiniApp',
  GS: 'GS'
});

// RMB currency symbol
export const CURRENCY_SYMBOL = '¥';

// Common configurations related to free shipping
export const FREE_SHIPPING = Object.freeze({
  FREE_SHIPPING_THRESHOLD: 300,
  SHOW_FREE_SHIPPING_PROMPT_THRESHOLD: 120
});

// Coupon status
export const COUPON_STATUS = Object.freeze({
  ACTIVE: 'ACTIVE',
  REDEEMED: 'REDEEMED',
  USED: 'USED',
  EXHAUSTED: 'EXHAUSTED',
  UNAVAILABLE: 'UNAVAILABLE'
});

// externalSellerId types
export const EXTERNAL_SELLER_ID = Object.freeze({
  DEFAULT: 'default'
});

// Used to create order request ID
export const ORDER_REQUEST_ID_LENGTH = 15;

// Icon management needs to match the corresponding icon data according to merchantId
export const MERCHANT_ID_BADGE_MAP = Object.freeze({
  A2EDK7H33M5FFG: {
    name: 'US',
    badgeName: '美国',
    badgeURL: ASIN_ITEM_ICONS_URLS.US_BADGE,
    iconURL: 'US.png'
  },
  A3TEGLC21NOO5Y: {
    name: 'UK',
    badgeName: '英国',
    badgeURL: ASIN_ITEM_ICONS_URLS.UK_BADGE,
    iconURL: 'UK.png'
  },
  A26HDXW89ZT98L: {
    name: 'JP',
    badgeName: '日本',
    badgeURL: ASIN_ITEM_ICONS_URLS.JP_BADGE,
    iconURL: 'JP.png'
  },
  A3CQWPW49OI3BQ: {
    name: 'GE',
    badgeName: '德国',
    badgeURL: ASIN_ITEM_ICONS_URLS.GE_BADGE,
    iconURL: 'GE.png'
  }
});

// app config types
export const APP_CONFIG_TYPES = {
  SETTING_PAGE: 'settingPage',
  CART_PAGE: 'cartPage',
  CHECKOUT_PAGE: 'checkoutPage',
  DETAIL_PAGE: 'dpPage'
};

// Asins' availability status
export const AVAILABILITY_STATUS = Object.freeze({
  IN_STOCK: 'IN_STOCK', // In stock
  IN_STOCK_SCARCE: 'IN_STOCK_SCARCE', // Scarce stock
  UNKNOWN_AVAILABILITY: 'UNKNOWN_AVAILABILITY',
  OUT_OF_STOCK: 'OUT_OF_STOCK' // Out of stock, currently out of stock
});

// deal types
export const DEAL_TYPES = Object.freeze({
  DEAL_OF_THE_DAY: 'DEAL_OF_THE_DAY',
  BEST_DEAL: 'BEST_DEAL'
});

//
export const SHARE_MODULE = {
  SHARE_TYPE: { shareLink: 'wx_link', shareImage: 'wx_image' },
  BTN_TYPE_FUNC: {
    shareWechat: 'handleShareWeChat',
    generateImages: 'handleGenerateImages',
    saveImages: 'handleSaveImages'
  },
  IMG_URL: {
    WECHAT_URL: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/Wechat.svg`,
    GENERATE_IMAGES_URL: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/GenerateImg.svg`,
    SAVE_IMAGES_URL: `${MEDIA_CENTRAL_LINKS.OLD_IMAGE_URL}assets/svg/icon/SaveImg.svg`
  },
  MAX_PIC_NUM: 6,
  WEBAPP_PROD_SUBDOMAIN: 'https://globalstore.amazon.cn',
  shareRouter: {
    DETAIL_PAGE: 'detailPage',
    GATEWAY: 'gateway',
    DOWNLOAD: 'download'
  }
};

// Asins added to cart and favorites status
export const ADD_CART_AND_FAVORITES_STATUS = Object.freeze({
  SUCCESSFUL: 0, // Add successfully
  FAILURE: -1, // Add failure
  EXCEED_MAX_LIMIT: -2, // Exceed maximum limit
  SINGLE_PRODUCT_EXCEED_MAX_LIMIT: -3 // Single product exceeds maximum limit
});
